exports.en = {
  UNIFORM_DETAIL: {
    INVALID_INPUT: 'Error.',
    ERROR_REQUIRED: 'Please fill in.'
  }
}
